import { SHORT_DATE } from '../constants/dates';
import dateFormatter from './dateFormatter';

export default function shortDate(date: any, timeZone: any) {
  return dateFormatter(date, SHORT_DATE, timeZone);
}
